import { combineReducers } from "redux";
import login from "./login";
import logout from "./logout";
import callsUpdate from "./callsUpdate";

// NOTE: use combineReducers to merge different reducers
export default combineReducers({login, logout, callsUpdate});
